import {memo} from "react";
import {Box, Flex, HStack, Separator, Text} from "@chakra-ui/react";
import {
  AdjustmentsHorizontalIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  FunnelIcon,
} from "@heroicons/react/16/solid";
import {Button} from "../../../../../components/ui/button";

/** Non-functional filter bar, styled to match filter bars elsewhere in the app. */
export const FilterBar = memo(({total}: {total: number}) => (
  <Flex align="center" px={6} py={2} borderBottom="1px solid" borderColor="gray.200" gap={3} bg="white">
    <Button size="xs" colorPalette="gray" variant="solid" bg="gray.800" color="white" _hover={{bg: "gray.700"}}>
      Default view
      <Box as={ChevronDownIcon} boxSize="14px" />
    </Button>
    <HStack gap={1} color="gray.800" cursor="pointer" _hover={{color: "gray.900"}}>
      <Box as={FunnelIcon} boxSize="13px" />
      <Text fontSize="xs" fontWeight="semibold">
        Filter...
      </Text>
    </HStack>
    <Flex flex={1} />
    <HStack gap={1} color="gray.800" cursor="pointer" _hover={{color: "gray.900"}}>
      <Box as={AdjustmentsHorizontalIcon} boxSize="13px" />
      <Text fontSize="xs" fontWeight="semibold">
        Display
      </Text>
    </HStack>
    <Separator orientation="vertical" h="20px" />
    <HStack gap={1.5} color="gray.800">
      <Box as="button" cursor="pointer" _hover={{color: "gray.900"}}>
        <Box as={ChevronLeftIcon} boxSize="13px" />
      </Box>
      <Text fontSize="xs" fontWeight="semibold" whiteSpace="nowrap">
        {`1 - ${total} of ${total}`}
      </Text>
      <Box as="button" cursor="pointer" _hover={{color: "gray.900"}}>
        <Box as={ChevronRightIcon} boxSize="13px" />
      </Box>
    </HStack>
  </Flex>
));
